import ProfileCard from '../components/ProfileCard';
import { KoobContainer, KoobCard, KoobTitle } from '@koob/ui';
import ProfileTabs from '../components/ProfileTabs';

export default function ProfileLayout({ user, children }) {
  return (
    <KoobContainer>
      <KoobTitle>Profile</KoobTitle>

      <KoobCard padding="none" style={{ marginTop: '0.75rem' }}>
        <div className="p-6">
          <ProfileCard user={user} />
        </div>

        <div className="p-6 flex-col space-y-5">{children}</div>
      </KoobCard>
    </KoobContainer>
  );
}
